import { subscriptionRepository } from '../repositories/subscription-repository';

async function getSubscriptionPlans() {
    return subscriptionRepository.getPlans();
}

export {
    getSubscriptionPlans
};
